module.exports = __webpack_public_path__ + "static/media/icon_specs-curve.53652e90.svg";